import Christ from "../../../entities/Christ/ui/Christ";

const ChristPage = () => {
    return ( 
        <main>
            <Christ/>
        </main>
     );
}
 
export default ChristPage;